/**
 * Detected CWE numbers from a PLA's source events: each `cwe` coerced to a number,
 * kept only when positive and finite (manual sources carry no CWE, so they drop
 * out as NaN), deduped, and sorted ascending.
 *
 * Shared by the assignment-level "CWEs Included" column (AspenAdaptTraining) and
 * the per-lesson CWE list (TrainingLessonsSidebar) so both normalize identically.
 */
export function extractCweNumbers(sources: ReadonlyArray<{ cwe?: unknown }>): number[] {
  const cweNumbers = new Set<number>();
  sources.forEach(source => {
    const cwe = Number(source.cwe);
    if (Number.isFinite(cwe) && cwe > 0) cweNumbers.add(cwe);
  });
  return [...cweNumbers].sort((left, right) => left - right);
}
